import { render } from "./Football.vue?vue&type=template&id=3188e0ca&scoped=true&ts=true"
import script from "./Football.vue?vue&type=script&setup=true&lang=ts"
export * from "./Football.vue?vue&type=script&setup=true&lang=ts"

import "./Football.vue?vue&type=style&index=0&id=3188e0ca&lang=scss&scoped=true"

import exportComponent from "/Users/luoke/Desktop/新开发代码_git/h5-jalalive/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3188e0ca"],['__file',"src/components/player/Football.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3188e0ca"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3188e0ca', __exports__)) {
    console.log('reload')
    api.reload('3188e0ca', __exports__)
  }
  
  module.hot.accept("./Football.vue?vue&type=template&id=3188e0ca&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('3188e0ca', render)
  })

}


export default __exports__